import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

export default function App() {
  const location = useLocation();

  // Process the OAuth callback FIRST (session_id lives in the URL fragment).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster position="top-center" theme="dark" />
    </>
  );
}
